import React, { useState, useEffect } from 'react';
import { isHauptadmin, getInfoValue } from '../../lib/globalData';
import dataProvider from '../../lib/dataProvider';
import { useTranslate, useRecordContext, useListContext, Pagination, List, Datagrid, required, 
  TextField, NumberField, Button, TextInput, BooleanInput, ReferenceInput, SelectInput }  from 'react-admin';
import { InputAdornment, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import MTextField from '@mui/material/TextField';
import { useForm, FormProvider } from 'react-hook-form';


const listFilter = [
  <TextInput source="res_nr" alwaysOn inputProps={{ 'data-lpignore': 'true', autoComplete: 'off' }} />,
];

const CustomPagination = () => {
  const { page, perPage, setPage, total } = useListContext();

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
      <Pagination page={page} perPage={perPage} setPage={setPage} total={total} rowsPerPageOptions={[5,10,25,50,100,500]} />
    </div>
  );
};

const CustomActions = ({tr}) => {
  const { filterValues, total, isLoading } = useListContext();

  if(!filterValues || !filterValues.res_nr)return
  return (
    <div style={{ display: 'flex' }}>
      { !isLoading && total===0 && isHauptadmin() && <ActionButton action="addCust" tr={tr} />}
      <ActionButton action="charge" tr={tr} />
    </div>
  )
}

const ActionButton = ({tr, action='refund'}) => {
  const [ dialogOpen, setDialogOpen ] = useState(false)
  const [ confirmOpen, setConfirmOpen ] = useState(false)
  const [ confirmContent, setConfirmContent ] = useState({})
  const { filterValues, isFetching, refetch } = useListContext()
  const [ cards, setCards ] = useState([])
  const [ data, setData ] = useState({add_res: true, id_zahlungsart: 0, ztext: '', amount: '', action: action, card_id: 1, cust: '' })
  const [ err, setErr ] = useState({id_zahlungsart: false, ztext: false, amount: false, cust: false})
  const rec = useRecordContext()
  const currency = getInfoValue('currency')
  const methods = useForm();
  const amountTxt=rec?.xml?rec.xml:''

  useEffect(() => {
    if((isFetching || cards.length===0) && filterValues && filterValues.res_nr && action==='charge' && dialogOpen){
      dataProvider.getList('setPayment/str_cust', { filter: {res_nr: filterValues.res_nr}, pagination: { page: 1, perPage: 1000 }, sort: { field: 'id', order: 'ASC' },})
      .then(res  => {
        if (res.data && res.data[0]) {
          setCards(res.data)
        } 
      })
    }
    // eslint-disable-next-line
  }, [filterValues, isFetching, dialogOpen])

  const handleUpdData = (field, value) => {
    var dat = {...data}
    dat[field] = value
    setData(dat)
  }
  const handleUpdErr = (field, value) => {
    var dat = {...err}
    dat[field] = value
    setErr(dat)
  }
  const handleRefund = () => {
    if(data.id_zahlungsart===0 && action!=='addCust')handleUpdErr('id_zahlungsart', true)
    else if((isNaN(data.amount) || data.amount==='') && action==='charge')handleUpdErr('amount', true)
    else if(data.ztext.length>13 && action==='charge')handleUpdErr('ztext', true)
    else if(data.cust.length<5 && action==='addCust')handleUpdErr('cust', true)
    else {
      dataProvider.update('setPayment/action', {id: rec?.id, data: {...data, ...{res_nr: filterValues.res_nr}}})
      .then(res  => {
        setDialogOpen(false)
        setConfirmContent(res.data)
        setConfirmOpen(true)
      })
    }
    console.log(data)
  }
  const handleConfirm = () => {
    setConfirmOpen(false)
    refetch()
  }
  if(action === "refund" && (!rec || !rec.charge || rec.refunded || rec.charge.slice(0,3) !== "ch_"))return
  return (
    <div>
      <Button sx={{color: action==='refund'?'red':'green', whiteSpace: 'nowrap'}} onClick={() => setDialogOpen(true)} label={"bw.set.payment.title."+action} />
      <Dialog open={dialogOpen} onClose={()=>setDialogOpen(false)} >
        <DialogTitle>{tr("bw.set.payment.title."+action)} </DialogTitle>
        <DialogContent sx={{ "& .lcont": { margin:"0.7em 0", width: '10em' }, "& .fcont": { margin:"0.7em 0" } }} >
          <FormProvider {...methods}>
            { action==='refund' && <div style={{ display: 'flex', gap: '1em' }}>
              <div className="lcont">{tr("bw.set.payment.resno")}: </div>
              <div className="fcont">{rec?.id_hostel}-{rec?.res_nr}</div>
            </div> }
            { action==="addCust" && <div>
              <div>{tr("bw.set.payment.addCustTxt")}</div>
              <div style={{ display: 'flex', gap: '1em' }}>
                <div className="lcont">{tr("bw.set.payment.resno")}: </div>
                <div className="fcont">{filterValues?.res_nr}</div>
              </div>
              <div style={{ display: 'flex', gap: '1em' }}>
              <div className="lcont">{tr("bw.set.payment.addCustLbl")}: </div>
              <MTextField source="cust" size="small" variant="standard" sx={{ width: '10em', mr: '2em' }} onBlur={(ev)=>{handleUpdData('cust', ev.target.value);handleUpdErr('cust', ev.target.value==='')}} helperText={err.cust?tr('bw.set.payment.notEmpty'):''} error={err.cust} />
              </div>
            </div> }
            { action==='refund' && <div style={{ display: 'flex', gap: '1em' }}>
              <div className="lcont">{tr("bw.set.payment.amount")}: </div>
              <div className="fcont">{amountTxt.split(':')[1]} (&asymp; {rec?.currency} {rec?.amount})</div>
            </div> }
            {action==='charge' && <div style={{ display: 'flex', gap: '1em' }}>
              <div className="lcont">{tr("bw.set.payment.amount")}: </div>
              <MTextField source="amount" size="small" variant="standard" InputProps={{ endAdornment: <InputAdornment position="end">{currency}</InputAdornment> }} sx={{ width: '10em', mr: '2em' }} onBlur={(ev)=>{handleUpdData('amount', ev.target.value);handleUpdErr('amount', isNaN(ev.target.value)||ev.target.value==='')}} helperText={err.amount?tr('bw.set.payment.nonNumeric'):''} error={err.amount} />
            </div>}
            {action==='charge' && <div style={{ display: 'flex', gap: '1em' }}>
              <div className="lcont">{tr("bw.set.payment.text")}: </div>
              <MTextField source="ztext" size="small" variant="standard" helperText={err.ztext?tr('bw.set.payment.max_text_error'):''} onBlur={(ev)=>{handleUpdData('ztext', ev.target.value);handleUpdErr('ztext', ev.target.value.length>13)}} error={err.ztext} sx={{ width: '24em' }} />
            </div>}
            {action==='charge' && <div style={{ display: 'flex', gap: '1em' }}>
              <div className="lcont">{tr("bw.set.payment.card")}: </div>
                <SelectInput source="card_id" optionText="bezeichnung" label={false} onChange={(ev)=>{handleUpdData('card_id', ev.target.value)}} size="small" choices={cards} sx={{ width: '24em', "& .MuiInputBase-root": { marginTop: 0 } }} variant="standard" />
            </div>}
            {action!=='addCust' && <div style={{ display: 'flex', gap: '1em' }}>
              <div className="lcont">{tr("bw.set.payment.dormproject")}: </div>
              <div className="fcont">
                <BooleanInput defaultValue={true} source="add_res" onChange={(ev)=>handleUpdData('add_res', ev.target.checked)} helperText={false} />
                <ReferenceInput source="id_zahlungsart" reference="setPaymenttype" >
                  <SelectInput optionText="bezeichnung" label="resources.setPayment.fields.id_zahlungsart" validate={required()} onChange={(ev)=>{handleUpdData('id_zahlungsart', ev.target.value);handleUpdErr('id_zahlungsart', ev.target.value<=0)}} sx={{ width: action==='refund'?'15em':'24em' }} error={err.id_zahlungsart} helperText={err.id_zahlungsart?'cannot be empty':''} variant="standard" />
                </ReferenceInput>
              </div>
            </div> }
          </FormProvider>
        </DialogContent>
        <DialogActions>
          <Button onClick={()=>setDialogOpen(false)} color="primary">
            <span>{tr("glob.close")}</span>
          </Button>
          <Button onClick={()=>handleRefund()} color="primary">
            <span>{tr("bw.set.payment."+action)}</span>
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={confirmOpen} onClose={()=>handleConfirm()} >
        <DialogTitle>{tr("bw.set.payment.title."+action)} </DialogTitle>
        <DialogContent sx={{ "& .lcont": { margin:"0.7em 0", width: '10em' }, "& .fcont": { margin:"0.7em 0" } }} >
          <div>{confirmContent?.msg ? tr(confirmContent.msg):''}</div>
          <div style={{ whiteSpace: 'pre-wrap', fontFamily: 'monospace', fontSize: '0.8em', marginTop: '1em' }}>
            {confirmContent?.log ? confirmContent.log:''}
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={()=>handleConfirm()} color="primary">
            <span>{tr("glob.close")}</span>
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

const DebugInfo = () => {
  const { filterValues, isFetching } = useListContext()
  const [ strLog, setStrLog ] = useState([])
  const content = []
  const styles = {
    cust: { fontWeight: 'bold' },
    data: { marginLeft: '1em', display: 'flex', flexDirection: 'row', gap: '1em', fontFamily: 'monospace', fontSize: '0.8em' },
    log: { whiteSpace: 'pre-wrap', fontFamily: 'monospace', fontSize: '0.8em' },
    meta: { marginLeft: '2em', whiteSpace: 'pre-wrap', fontFamily: 'monospace' },
  }
  useEffect(() => {
    if(isFetching && filterValues && filterValues.res_nr){
      setTimeout(()=>{dataProvider.getList('setPayment/str_log', { filter: {res_nr: filterValues.res_nr}, pagination: { page: 1, perPage: 1000 }, sort: { field: 'id', order: 'ASC' },})
      .then(res  => {
        if (res.data && res.data[0]) {
          setStrLog(res.data)
        } 
      })}, 1000)
    }
  }, [filterValues, isFetching])
  strLog.forEach((it, idx)=>{
    if(it?.cust)content.push(<div key={'cust'+idx} style={styles['cust']}>{it.cust}</div>)
    if(it?.data)content.push(<div key={'data'+idx} style={styles['data']}>
      {it.data.split("\t").map((el, id)=><div key={'de'+id}>{el}</div>)}
      {it?.meta ? <div key={'meta'+idx} style={styles['meta']}>{it.meta}</div> : ''}
      </div>)
    if(it?.log)content.push(<div key={'log'+idx} style={styles['log']}>{
      it.log.split("\n").map((el, id)=><div key={'le'+id}>{el}</div>)
      }</div>)
  })
  return (
    <>
      <h3>Stripe Log:</h3>
      <div>{content}</div>
    </>
  )
}


const ListForm = (props) => {
  const tr = useTranslate();
  return (
    <>
      <List actions={<CustomActions tr={tr} />} filters={listFilter} sort={{ field: 'dat', order: 'DESC' }} 
        pagination={<CustomPagination />} perPage={50} empty={false} 
      >
        <Datagrid style={{ width: 'auto' }} bulkActionButtons={false} >
          <TextField source="charge" />
          <TextField source="dat" />
          <TextField source="currency" />
          <NumberField source="amount" options={{ maximumFractionDigits: 2 }} />
          <TextField source="xml" />
          <NumberField source="costs" options={{ maximumFractionDigits: 2 }} />
          <NumberField source="hostel" options={{ maximumFractionDigits: 2 }} />
          <NumberField source="bookingfee" options={{ maximumFractionDigits: 2 }} />
          <NumberField source="commission" options={{ maximumFractionDigits: 2 }} />
          <NumberField source="admin3" options={{ maximumFractionDigits: 2 }} />
          <NumberField source="connected" options={{ maximumFractionDigits: 2 }} />
        {isHauptadmin() &&
          <TextField source="id" textAlign="right" />
        }
          <ActionButton label="" tr={tr} />
        </Datagrid>
        {isHauptadmin() &&
          <DebugInfo />
        }
      </List>
    </>
  )
}

const SetPayment = {
  list: ({ classes, ...props }) => (
    <ListForm {...props} />
  )
}
export default SetPayment